// extracted by mini-css-extract-plugin
export default {"app-wrapper":"App_app-wrapper__comPB","long-bar":"App_long-bar__cedaz"};